'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var grey = require('../node_modules/@material-ui/core/esm/colors/grey.js');
var blue = require('../node_modules/@material-ui/core/esm/colors/blue.js');
var pink = require('../node_modules/@material-ui/core/esm/colors/pink.js');
var blueGrey = require('../node_modules/@material-ui/core/esm/colors/blueGrey.js');
var createMuiTheme = require('../node_modules/@material-ui/core/esm/styles/createMuiTheme.js');

var hoverColor = "rgba(33, 150, 243, 0.08)";
var styles = {
  palette: {
    common: {
      black: grey[900],
      white: '#FFFFFF'
    },
    primary: {
      light: blue[100],
      main: '#0E6FBE',
      dark: '#0D47A1',
      contrastDefaultColor: 'light',

      /** @deprecated use primary.light instead */
      '50': blue[50]
    },
    secondary: {
      light: grey[500],
      main: grey[700],
      dark: grey[800],
      contrastDefaultColor: 'dark',

      /** @deprecated use grey[400] instead */
      '400': grey[400],

      /** @deprecated use grey[300] instead */
      '300': grey[300],

      /** @deprecated use grey[200] instead */
      '200': grey[200],

      /** @deprecated use grey[100] instead */
      '100': grey[100]
    },
    error: {
      light: '#FFDDE9',
      main: pink[600],
      dark: '#880E4F',
      contrastDefaultColor: 'light'
    },
    warning: {
      light: '#FFF1C6',
      main: '#BF8600',
      dark: '#8C5400',
      contrastDefaultColor: 'dark'
    },
    info: {
      light: '#DEF0FF',
      main: '#0E6FBE',
      dark: '#094AB0',
      contrastDefaultColor: 'light',

      /** @deprecated use info.light instead */
      '50': blue[50]
    },
    success: {
      light: '#DCF9D7',
      main: '#00A344',
      dark: '#00662B',
      contrastDefaultColor: 'dark'
    },
    action: {
      hover: blue[50],
      hoverOpacity: 0.08,
      focusOpacity: 0.16
    },
    text: {
      primary: grey[900],
      secondary: grey[700],
      disabled: grey[400],
      hint: 'rgba(0, 0, 0, 0.38)',
      reverse: '#FFFFFF',

      /** @deprecated use text.primary instead */
      main: grey[900]
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    border: {
      light: grey[300],
      dark: grey[600]
    },
    background: {
      "default": grey[50],
      paper: '#FFFFFF',
      contrastDefaultColor: 'dark',

      /** @deprecated use background.default instead */
      main: grey[50],

      /** @deprecated use background.paper instead */
      white: '#FFFFFF'
    },

    /** @deprecated use primary instead */
    brandPrimary: {
      main: blueGrey[900],
      dark: blueGrey[800],
      light: blueGrey[50],
      contrastDefaultColor: 'light'
    },

    /** @deprecated use primary instead */
    brandPrimaryLight: {
      main: blueGrey[50],
      contrastDefaultColor: 'dark'
    },

    /** @deprecated use warning instead */
    alert: {
      light: '#FFE082',
      main: '#BF8600',
      dark: '#8C5400',
      contrastDefaultColor: 'dark'
    },

    /** @deprecated */
    hover: {
      main: "rgba(33, 150, 243, 0.08)"
    },

    /** @deprecated use background.paper instead */
    paper: {
      main: '#FFFFFF',
      contrastDefaultColor: 'dark'
    },

    /** @deprecated */
    settingsColor: {
      main: "#00314a"
    },

    /** @deprecated use common.white instead */
    white: {
      main: "#FFFFFF",
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, .7)",
      tertiary: "rgba(255, 255, 255, .5)"
    },

    /** @deprecated use common.black or gray instead */
    black: {
      primary: '#212121',
      secondary: "rgba(0, 0, 0, .54)",
      tertiary: "rgba(0, 0, 0, .38)"
    },

    /** @deprecated */
    aliceBlue: {
      main: blue[50],
      contrastDefaultColor: 'light'
    }
  },
  spacer: {
    centerContentMaxWidth: 1250
  },
  typography: {
    fontFamily: 'Open sans, Lato, Arial, sans-serif',
    caption: {
      fontSize: '0.75rem',
      lineHeight: 4 / 3,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 11 / 7,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    subtitle2: {
      fontSize: '1rem',
      lineHeight: 1.375,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    subtitle1: {
      fontSize: '1.125rem',
      lineHeight: 4 / 3,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h6: {
      fontSize: '1.375rem',
      lineHeight: 16 / 11,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h5: {
      fontSize: '1.75rem',
      lineHeight: 20 / 14,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h4: {
      fontSize: '2.5rem',
      lineHeight: 1.2,
      fontWeight: 600,
      fontStyle: 'normal'
    },
    h3: {
      fontSize: '1.375rem',
      lineHeight: 16 / 11,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    h2: {
      fontSize: '1.75rem',
      lineHeight: 20 / 14,
      fontWeight: 400,
      fontStyle: 'normal'
    },
    h1: {
      fontSize: '2.5rem',
      lineHeight: 1.2,
      fontWeight: 400,
      fontStyle: 'normal'
    },

    /** eyebrow and button are not part of our design system, but we're keeping them to support old theme. */
    eyebrow: {
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '32px',
      letterSpacing: 1,
      color: grey[700],
      fontStyle: 'normal',
      textTransform: 'uppercase'
    },
    button: {
      fontSize: 14,
      lineHeight: 1.14,
      fontWeight: 600
    }
  },
  customShadows: {
    card: '0px 0px 12px 2px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1), 0px 0px 0px 0px rgba(0, 0, 0, .1)'
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#fff",
        cursor: 'default',
        borderBottom: 'solid 1px #e0e0e0',
        color: "rgba(0, 0, 0, .87)"
      },
      colorSecondary: {
        backgroundColor: "#00314a",
        cursor: 'default',
        color: '#fff'
      }
    },
    MuiButton: {
      root: {
        minHeight: 36
      },
      sizeSmall: {
        minHeight: 32
      },
      sizeLarge: {
        minHeight: 44
      },
      text: {
        fontFamily: 'Open sans, Lato, Arial, sans-serif'
      }
    },
    MuiTableRow: {
      root: {
        '&$selected': {
          backgroundColor: "rgba(33, 150, 243, 0.16)"
        },
        '&$hover:hover': {
          backgroundColor: hoverColor
        }
      },
      selected: {},
      hover: {}
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: hoverColor
        }
      }
    }
  }
};
var theme = createMuiTheme(styles);

exports.styles = styles;
exports.theme = theme;
